import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchSumcharge } from './sumchargeAPI'; // Assume this API function accepts filters as a parameter.

const initialState = {
  data: [],
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};


// Async thunk to fetch data with filters
export const fetchSumchargeDataWithFilters = createAsyncThunk(
  'Sumcharge/fetchSumchargeDataWithFilters',
  async ({ filter = {}, options = {} }) => {    
    const response = await fetchSumcharge({ filter, options }); // Pass filters to the API    
    return response.data; // Assuming the API response contains a `data` field
  }
);

export const sumchargeSlice = createSlice({
  name: 'sumcharge',
  initialState,
  reducers: {}, // No need for additional reducers in this simplified version
  extraReducers: (builder) => {
    builder
      .addCase(fetchSumchargeDataWithFilters.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchSumchargeDataWithFilters.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload; // Store the fetched data
      })
      .addCase(fetchSumchargeDataWithFilters.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message; // Store error message
      });
  },
});

// Selector to access the data and status
export const selectSumchargeData = (state) => state.sumcharge.data;
export const selectSumchargeStatus = (state) => state.sumcharge.status;
export const selectSumchargeError = (state) => state.sumcharge.error;

export default sumchargeSlice.reducer;
